import { registrationApproveApi } from "../../api/registration/registrationApproveApi"

type PayloadShape = Parameters<typeof registrationApproveApi>[0]

export async function registrationApproveService(payload: PayloadShape, token: string) {
	return await registrationApproveApi(payload, token)
}
